module.exports = __webpack_public_path__ + "c64f37dae467728d8f7ea1c828e130f2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/lightbulb-on.png
// module id = 1642
// module chunks = 0